import { StyledInput } from "../ui";

const Base = StyledInput.withComponent("select");
const StyledSelect = Base.extend`
  /* border-radius: 0;
  border-top: 0;
  border-right: 0;
  border-left: 0; */
  appearance: none;
  padding-left: 1rem;

  .error & {
    padding-left: 1.625rem;
  }
`;

export default StyledSelect;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/ui/StyledSelect.js